import { Product, ProductImageType, ProductType } from '../../context/CartContext';

// Street Signs Images
import localStreetSignsImage from '../../assets/images/locals/product_local_street_sign_front1.webp';
import localStreetSignCityLimitsYourCity from '../../assets/images/locals/product_local_sign_citylimits_yourcity.webp';
import localStreetSignsSummary from '../../assets/images/locals/product_local_street_sign_summary.webp';
import localStreetSignFrontAndBack from '../../assets/images/locals/product_local_street_sign_magnet_front_and_back.webp';

export const localsProducts: Product[] = [
  {
    id: '6000',
    name: 'Customized Street Sign Magnet',
    price: 5,
    wholesale_price: 3,
    height_inches: 1,
    width_inches: 2.5,
    depth_inches: 0.5,
    images: [
      { image_path: localStreetSignsImage, image_type: ProductImageType.DETAIL },
      { image_path: localStreetSignsSummary, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 10,
    product_type: ProductType.LOCALS,
    category: 'Street Signs',
    sub_category: 'Customizable',
    description: 'Customize your street sign with any name.',
    is_customizeable: true,
    customization_items: [{ name: 'Name', max_length: 20, customText: 'Your Street' }]
  },
  {
    id: '6010',
    name: 'Customized City Limits Magnet',
    price: 6,
    wholesale_price: 4,
    height_inches: 2.6,
    width_inches: 3.25,
    depth_inches: 0.5,
    images: [
      { image_path: localStreetSignCityLimitsYourCity, image_type: ProductImageType.DETAIL },
      { image_path: localStreetSignsSummary, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 12,
    product_type: ProductType.LOCALS,
    category: 'City Signs',
    sub_category: 'Customizable',
    description: 'Customize with city name, population, and elevation.',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Your City' },
      { name: 'Population', max_length: 20, customText: '21,380' },
      { name: 'Elevation', max_length: 20, customText: '980 ft.' }
    ]
  },
  {
    id: '6101',
    name: 'NWA Customized Street Sign Magnet with Rocks',
    price: 7,
    wholesale_price: 4,
    height_inches: 1,
    width_inches: 2.5,
    depth_inches: 0.5,
    images: [
      { image_path: localStreetSignsImage, image_type: ProductImageType.DETAIL },
      { image_path: localStreetSignFrontAndBack, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 15,
    product_type: ProductType.LOCALS,
    category: 'Street Signs',
    sub_category: 'Customizable',
    description: 'Customize with your street name.  Includes authentic samples of the Northwest Arkansas region.',
    is_customizeable: true,
    customization_items: [{ name: 'Name', max_length: 20, customText: 'Your Street' }]
  },
  {
    id: '6111',
    name: 'NWA City Limits Magnet with Rocks',
    price: 8,
    wholesale_price: 5,
    height_inches: 2.6,
    width_inches: 3.25,
    depth_inches: 0.5,
    images: [
      { image_path: localStreetSignCityLimitsYourCity, image_type: ProductImageType.DETAIL },
      { image_path: localStreetSignsSummary, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 35,
    product_type: ProductType.LOCALS,
    category: 'City Signs',
    sub_category: 'Customizable',
    description: 'Customize with city name, population, and elevation.  Includes authentic samples of the Northwest Arkansas region. ',
    is_customizeable: true,
    customization_items: [
      { name: 'Name', max_length: 20, customText: 'Your City' },
      { name: 'Population', max_length: 20, customText: '21,380' },
      { name: 'Elevation', max_length: 20, customText: '980 ft.' }
    ]
  }
];
